/* eslint-disable consistent-return */
import axios from "axios";
import { API_CATEGORIES } from "./api";

const getCategories = async () => {
  try {
    const response = await axios.get(API_CATEGORIES);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export default getCategories;
